import { render, staticRenderFns } from "./historical.vue?vue&type=template&id=0b0d25bc&scoped=true"
import script from "./historical.vue?vue&type=script&lang=js"
export * from "./historical.vue?vue&type=script&lang=js"
import style0 from "./historical.vue?vue&type=style&index=0&id=0b0d25bc&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d25bc",
  null
  
)

export default component.exports